import { connect } from 'react-redux';
import { createToolbarEvent } from '../../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../../analytics/functions';
import { translate } from '../../../base/i18n/functions';
import { IconShareDoc } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { closeOverflowMenuIfOpen } from '../../../toolbox/actions.web';
import { isAiNotesEnabled, isAiNotesPanelVisible } from '../../functions';
import { SidePanelTabId } from '../../../side-panel/constants';
import { toggleSidePanelApp } from '../../../side-panel/actions';
/**
 * 「应用」菜单 / 主栏中的 AI纪要入口.
 */
class AiNotesButton extends AbstractButton {
    accessibilityLabel = 'toolbar.accessibilityLabel.ainotes';
    icon = IconShareDoc;
    label = 'toolbar.ainotes';
    tooltip = 'toolbar.ainotes';
    toggledAccessibilityLabel = 'toolbar.accessibilityLabel.closeAinotes';
    toggledTooltip = 'toolbar.closeAinotes';
    /**
     * {@inheritdoc}
     */
    _isToggled() {
        return this.props._isOpen;
    }
    /**
     * {@inheritdoc}
     */
    _handleClick() {
        const { dispatch } = this.props;
        sendAnalytics(createToolbarEvent('ainotes'));
        dispatch(closeOverflowMenuIfOpen());
        dispatch(toggleSidePanelApp(SidePanelTabId.AI_NOTES));
    }
}
/**
 * Maps redux state to component props.
 *
 * @param {Object} state - Redux state.
 * @returns {Object}
 */
function mapStateToProps(state) {
    return {
        _isOpen: isAiNotesPanelVisible(state),
        visible: isAiNotesEnabled(state)
    };
}
export default translate(connect(mapStateToProps)(AiNotesButton));
